var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListLayout',{attrs:{"title":_vm.$route.meta.title}},[_c('ItemList',{attrs:{"type":"playlists","items":[_vm.playlistWithFavoritesTracks ].concat( _vm.playlists),"creator":_vm.creator}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }